import { ExternalLink } from 'lucide-react';

const pressLinks = [
  {
    name: 'Bitcoinist',
    logo: '/press/bitcoinist.webp',
    url: 'https://bitcoinist.com'
  },
  {
    name: 'CryptoNews',
    logo: '/press/cnews-logo-new.svg',
    url: 'https://cryptonews.com'
  },
  {
    name: 'CoinPedia',
    logo: '/press/coinpedia-logo.svg',
    url: 'https://coinpedia.org'
  },
  {
    name: 'NewsBTC',
    logo: '/press/newsbtc.webp',
    url: 'https://newsbtc.com'
  }
];

export default function Press() {
  return (
    <div className="py-10 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <h2 className="font-tokyo text-3xl font-bold bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent mb-2">
            Featured In
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-center">
          {pressLinks.map((press) => (
            <a
              key={press.name}
              href={press.url}
              target="_blank"
              rel="noopener noreferrer"
              className="quantum-card p-4 flex items-center justify-center group hover:scale-105 transition-all duration-300"
            >
              <div className="relative">
                <img
                  src={press.logo}
                  alt={press.name}
                  className="h-8 w-auto object-contain filter brightness-0 invert opacity-50 group-hover:opacity-100 transition-all duration-300"
                />
                <ExternalLink className="w-4 h-4 absolute -top-2 -right-2 text-quantum-primary opacity-0 group-hover:opacity-100 transition-all duration-300" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}